import { Checkbox as Root } from '@/ui/Checkbox'
import { CheckboxProps as RootProps } from '@/ui/Checkbox'
import { useController, UseControllerProps } from 'react-hook-form'

interface Props extends UseControllerProps, RootProps {
    name: string
    label: string
}

export const Checkbox = ({ ...props }: Props) => {
    const { field } = useController({ control: props.control, name: props.name })
    field.value = field.value || false

    return <Root onChange={field.onChange} checked={field.value} {...props} />
}
